import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AmibrokerState {
  isEnabled: boolean;
  isInitialized: boolean;
}

const initialState: AmibrokerState = {
  // Always start disabled on fresh app open; runtime lifecycle manages enablement.
  isEnabled: false,
  isInitialized: false,
};

const amibrokerSlice = createSlice({
  name: "amibroker",
  initialState,
  reducers: {
    setAmibrokerEnabled: (state, action: PayloadAction<boolean>) => {
      state.isEnabled = action.payload;
    },
    setAmibrokerInitialized: (state, action: PayloadAction<boolean>) => {
      state.isInitialized = action.payload;
    },
  },
});

export const { setAmibrokerEnabled, setAmibrokerInitialized } = amibrokerSlice.actions;
export default amibrokerSlice.reducer;
